/**
 * screens/dashboard/dashboard.mock.ts
 * Dashboard data loader — now wired to the real GET /api/hire/v2/dashboard.
 * (Filename kept for import stability; the mock has been replaced by the live
 * endpoint. Falls back to an empty shape if the call fails so the screen still
 * renders.)
 */
import axiosInstance from '../../api/axiosInstance';
import { HireMatch_Dashboard_Url } from '../../api/endpoints';
import type { DashboardData } from '../../schemas/hire/home';

const EMPTY: DashboardData = {
  activeJobs: 0,
  draftJobs: 0,
  jobStatusSplit: [],
  candidatesIngested: 0,
  sourceSplit: [],
  consentExpiringCount: 0,
  credits: { balance: 0, cap: 0 },
  aiUsage: { inputTokens: 0, outputTokens: 0, totalTokens: 0, rerankRuns: 0 },
  recentRuns: [],
  consentExpiring: [],
  ingest: { queued: 0, extracted: 0, embedded: 0, failed: 0 },
};

export async function loadDashboard(): Promise<DashboardData> {
  try {
    const { data } = await axiosInstance.get<DashboardData>(HireMatch_Dashboard_Url);
    return data ?? EMPTY;
  } catch {
    return EMPTY;
  }
}
